import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import contentStyle from '../../styles/containers/contentStyle';

@Radium
class Content extends React.Component {
  render() {
    return (
      <main style={contentStyle.container}>
        <div style={contentStyle.content}>{this.props.children}</div>
      </main>
    );
  }
}

Content.propTypes = {
  children: PropTypes.element,
};

Content.defaultProps = {
  children: null,
};

export default Content;
